/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InboundOutBoundPicVo } from './InboundOutBoundPicVo';
import {
    InboundOutBoundPicVoFromJSON,
    InboundOutBoundPicVoFromJSONTyped,
    InboundOutBoundPicVoToJSON,
    InboundOutBoundPicVoToJSONTyped,
} from './InboundOutBoundPicVo';

/**
 * 
 * @export
 * @interface ResponseListInboundOutBoundPicVo
 */
export interface ResponseListInboundOutBoundPicVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListInboundOutBoundPicVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListInboundOutBoundPicVo
     */
    message?: string;
    /**
     * 
     * @type {Array<InboundOutBoundPicVo>}
     * @memberof ResponseListInboundOutBoundPicVo
     */
    data?: Array<InboundOutBoundPicVo>;
}

/**
 * Check if a given object implements the ResponseListInboundOutBoundPicVo interface.
 */
export function instanceOfResponseListInboundOutBoundPicVo(value: object): value is ResponseListInboundOutBoundPicVo {
    return true;
}

export function ResponseListInboundOutBoundPicVoFromJSON(json: any): ResponseListInboundOutBoundPicVo {
    return ResponseListInboundOutBoundPicVoFromJSONTyped(json, false);
}

export function ResponseListInboundOutBoundPicVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListInboundOutBoundPicVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(InboundOutBoundPicVoFromJSON)),
    };
}

export function ResponseListInboundOutBoundPicVoToJSON(json: any): ResponseListInboundOutBoundPicVo {
    return ResponseListInboundOutBoundPicVoToJSONTyped(json, false);
}

export function ResponseListInboundOutBoundPicVoToJSONTyped(value?: ResponseListInboundOutBoundPicVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(InboundOutBoundPicVoToJSON)),
    };
}

